import { Alert, Button, Modal, Typography } from "antd";
import styles from "../../deliveryServices/DeliveryServices.module.css";
import { ExclamationCircleFilled } from "@ant-design/icons";

const { Text } = Typography;

export default function GrubhubDialogConfirm({
  handleSubmit,
  isSubmitting,
  showModal,
  handleCloseModal,
  errors,
}) {
  return (
    <Modal
      centered
      open={showModal}
      onCancel={handleCloseModal}
      footer={[null]}
      closable={false}
      maskClosable={false}
    >
      <div style={{ display: "flex", gap: 12 }}>
        <ExclamationCircleFilled
          style={{ color: "#007aff", fontSize: 20, marginTop: -20 }}
        />
        <div>
          <Text strong style={{ fontSize: 16 }}>
            Confirm Submission
          </Text>
          <p className={styles.dsFormLabels}>
            Are you sure you want to submit this information?
          </p>
        </div>
      </div>
      <div
        style={{
          marginTop: 24,
          display: "flex",
          justifyContent: "flex-end",
          gap: 12,
        }}
      >
        <Button
          onClick={handleCloseModal}
          disabled={isSubmitting}
          style={{ marginRight: 8 }}
        >
          Keep Editing
        </Button>
        <Button
          type="primary"
          onClick={handleSubmit}
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Submit
        </Button>
      </div>
      {errors && Array.isArray(errors) ? (
        <Alert
          closable={false}
          message={(errors || []).map((error) => (
            <Text>{error}</Text>
          ))}
          type="error"
          showIcon
          style={{ marginTop: "3%" }}
        />
      ) : errors && !Array.isArray(errors) ? (
        <Alert
          closable={false}
          message={(errors || []).map((error) => (
            <Text>{error}</Text>
          ))}
          type="error"
          showIcon
          style={{ marginTop: "3%" }}
        />
      ) : null}
    </Modal>
  );
}
